import { HStack, IconButton, Stack, SuitabilityWalletPoints, Text } from '@genial/components';
import React from 'react';

import { useRecoilQuery } from '../../hooks/useRecoilQuery';
import { TextSkeleton } from '../../pages/BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { customerWalletPointsQuery } from '../../store/customer/selector';

export interface CustomerWalletPointsProps {
  accountNumber: number;
  preventPadding?: boolean;
}

export const CustomerWalletPoints: React.FC<CustomerWalletPointsProps> = ({
  accountNumber,
  preventPadding,
}) => {
  const { data, loading, error, refresher } = useRecoilQuery(
    customerWalletPointsQuery({ accountNumber })
  );

  if (loading) {
    return (
      <Stack py={preventPadding ? 0 : 'inset.quarck'} w="full">
        <TextSkeleton />
      </Stack>
    );
  }

  if (error || !data) {
    return (
      <HStack alignItems="center" space="inline.nano">
        <Text color="brand.tertiary.principal">Recarregar</Text>
        <IconButton
          testId="refresh-wallet-points"
          variant="ghost"
          padding="inset.quarck"
          icon="Refresh"
          iconSize="xxxs"
          iconColor="brand.tertiary.principal"
          onPress={refresher}
        />
      </HStack>
    );
  }

  return (
    <Stack py={preventPadding ? 0 : 'inset.quarck'}>
      <SuitabilityWalletPoints currentPoints={data.currentPoints} limitPoints={data.limitPoints} />
    </Stack>
  );
};
